import { HTTP } from "@/common/http-common";

const RESOURCE_NAME = "entities/courses";

export default {
  async getAll(options = {}) {
    const response = await HTTP.get(`${RESOURCE_NAME}`, options);
    return response.data;
  },

  async get(id) {
    return (await HTTP.get(`${RESOURCE_NAME}/${id}`)).data;
  },

  async save(entity) {
    if (entity.id) {
      return (await HTTP.put(`${RESOURCE_NAME}/${entity.id}`, entity)).data;
    } else {
      return (await HTTP.post(`${RESOURCE_NAME}`, entity)).data;
    }
  },

  async duplicate(courseToDuplicate) {
    return (await HTTP.post(`${RESOURCE_NAME}/duplicate`, courseToDuplicate))
      .data;
  },

  async delete(id) {
    return (await HTTP.delete(`${RESOURCE_NAME}/${id}`)).data;
  },
};
